import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, ChevronRight, Menu, X } from 'lucide-react';
import logo from "../assets/images/logo.png";
import "../assets/css/navbar.css";
import Adresse from "../assets/images/accordion-icons/home.png"
import Call from "../assets/images/accordion-icons/call.png"
import Email from "../assets/images/accordion-icons/email.png";
import pdf1 from "../assets/catalog/mdf-medelack-catalogue-01.pdf";
import pdf2 from "../assets/catalog/catalogue-mdf-color.pdf";
import pdf3 from "../assets/catalog/marbre-et-granite.pdf";

const SogereuNavbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const menuItems = [
    { name: 'Accueil', id: 'accueil' },
    { name: 'À propos', id: 'propos' },
    { name: 'Nos produits', id: 'produits' },
    { name: 'Nos services', id: 'services' },
    { name: 'Contactez-Nous', id: 'contact_form' },
  ];
  const [isCatalogueOpen, setIsCatalogueOpen] = useState(false);
  const dropdownRef = useRef(null);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsCatalogueOpen(false);
      setIsMobileMenuOpen(false);
    }
  };


 const catalogueItems = [
  {
    name: 'MDF MEDELACK LOGIMAR',
    hasSubmenu: true,
    href: pdf1,
    downloadName: 'mdf-medelack-catalogue-01.pdf'
  },
  {
    name: 'MDF COLOR',
    hasSubmenu: true,
    href: pdf2,
    downloadName: 'catalogue-mdf-color.pdf'
  },
  {
    name: 'MDF LOGIMAR',
    hasSubmenu: true,
    href: '#',
  },
  {
    name: 'Marbre & granite',
    hasSubmenu: true,
    href: pdf3,
    downloadName: 'marbre-et-granite.pdf'
  }
];
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 780);
    handleResize();
    window.addEventListener('resize', handleResize);

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCatalogueOpen(false);
      }
    };
    
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full relative">
      {/* Top Header */}
      {/* Top Header */}
      <div className={`relative w-full flex ${isMobile ? 'flex-col-reverse' : 'flex-row'} h-40 
  xxl:h-48 3xl:h-56 4xl:h-64`}>

        {/* Orange part (Logo) */}
        <div
          className={`${isMobile ? 'w-full' : 'w-[30%]'} logo_container
      bg-gradient-to-br from-[#F38820] to-[#F38820] relative flex items-center 
      px-4 sm:px-6 lg:px-8 py-1 sm:py-4
      xxl:px-10 xxl:py-6 3xl:px-12 3xl:py-7 4xl:px-16 4xl:py-8`}
          style={isMobile ? {} : { clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0% 100%)' }}
        >
          <div className="w-full flex items-center justify-between orange_part">
            {/* Logo on the left */}
            <img
              src={logo}
              alt="SOGEREU Logo"
              className="sogerev_logo"
            />

            {/* Mobile menu button on the right */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white p-2 menu_1"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

        </div>

        {/* Gray part (Info) */}
        <div className={`${isMobile ? 'w-full' : 'w-[70%]'}
     cordoner_container px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center
      xxl:px-10 xxl:py-6 3xl:px-12 4xl:px-16  `}>

          <div className="flex flex-wrap items-center gap-4 sm:gap-6 lg:gap-8 justify-start
                    xxl:gap-10 3xl:gap-12 4xl:gap-16">

            {/* Phone */}
            <a
              href="tel:+212660343555"
              className="flex items-center gap-2 sm:gap-3 xxl:gap-4 4xl:gap-6 hover:opacity-80 transition-opacity duration-200"
              aria-label="Call (+212) 6 60 34 35 55"
            >
              <img
                src={Call}
                className="w-6 h-6 sm:w-8 sm:h-8 xxl:w-10 xxl:h-10 3xl:w-12 3xl:h-12 4xl:w-16 4xl:h-16"
                alt="Call icon"
              />
              <div className="flex flex-col text-xs text_small xxl:text-xl 3xl:text-2xl 4xl:text-2xl  5xl:text-2xl 6xl:text-2xl 7xl:text-3xl ">
                <span className="font-semibold text-gray-700 title_cord font-encode">Numéro de téléphone</span>
                <span className="text-gray-600 subtitle_cord font-encode">(+212) 6 60 34 35 55</span>
              </div>
            </a>

            {/* Email */}
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=contact@sogerev.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 sm:gap-3 xxl:gap-4 4xl:gap-6 hover:opacity-80 transition-opacity duration-200"
              aria-label="Send email to contact@sogerev.com"
            >
              <img
                src={Email}
                className="w-6 h-6 sm:w-8 sm:h-8 xxl:w-10 xxl:h-10 3xl:w-12 3xl:h-12 4xl:w-16 4xl:h-16"
                alt="Email icon"
              />
              <div className="flex flex-col text-xs text_small xxl:text-xl  3xl:text-2xl 4xl:text-2xl  5xl:text-2xl 6xl:text-2xl 7xl:text-3xl ">
                <span className="font-semibold text-gray-700 title_cord font-encode">E-mail ici</span>
                <span className="text-gray-600 subtitle_cord font-encode">contact@sogerev.com</span>
              </div>
            </a>
            {/* Address - Link to Google Maps */}
            <a href="https://maps.app.goo.gl/CXncDv3uQKVtuDaF9"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 sm:gap-3 xxl:gap-4 4xl:gap-6 hover:opacity-80 transition-opacity duration-200"
              aria-label="Open address in Google Maps"
            >
              <img
                src={Adresse}
                className="w-6 h-6 sm:w-8 sm:h-8 xxl:w-10 xxl:h-10 3xl:w-12 3xl:h-12 4xl:w-16 4xl:h-16"
                alt="Address icon"
              />
              <div className="flex flex-col text-xs text_small xxl:text-xl 3xl:text-2xl 4xl:text-2xl  5xl:text-2xl 6xl:text-2xl 7xl:text-3xl ">
                <span className="font-semibold text-gray-700 title_cord font-encode">Adresse</span>
                <span className="text-gray-600 subtitle_cord font-encode">km 8 Route Moulay Thami, Casablanca 20250</span>
              </div>
            </a>

          </div>

        </div>
      </div>


      {/* Navigation Menu */}
      <nav className="absolute left-1/2 transform -translate-x-1/2 top-32 
        w-[90%] lg:w-[70%] bg-[#002447] shadow-lg z-50 nav-bare
        xxl:top-40 3xl:top-48 4xl:top-56">

        <div className="px-4 sm:px-6 lg:px-8 py-2 
          xxl:px-10 xxl:py-4 3xl:px-12 4xl:px-16 flex items-center justify-between">

          {/* Desktop Links */}
          <ul className="hidden lg:flex items-center space-x-2 text-sm
            xxl:text-lg xxl:space-x-4
            3xl:text-xl 3xl:space-x-6
            4xl:text-2xl 4xl:space-x-10">
            {menuItems.map((item, index) => (
              <li key={index}>
                <a
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(item.id);
                  }}
                  className="px-3 py-2 hover:text-[#F38820] text-white transition
                   xxl:px-4 3xl:px-6 4xl:px-8 font-encode"
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex gap-2 xxl:gap-3 3xl:gap-4 4xl:gap-6 relative" ref={dropdownRef}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsCatalogueOpen(!isCatalogueOpen);
              }}
              className="px-4 py-2 bg-[#F38820] text-white text-sm font-semibold flex items-center gap-1 
            xxl:px-6 xxl:py-3 xxl:text-lg 
            3xl:px-7 3xl:py-4 3xl:text-xl 
            4xl:px-8 4xl:py-5 4xl:text-2xl
            hover:bg-[#e07a1a] transition-colors font-encode"
            >
              CATALOGUES
              <ChevronDown
                size={16}
                className={`xxl:w-6 3xl:w-7 4xl:w-8 transition-transform duration-300 ${isCatalogueOpen ? 'rotate-180' : ''
                  }`}
              />
            </button>

            <button onClick={() => scrollToSection('contact_form')} className="px-4 py-2 bg-[#F38820] text-white text-sm font-semibold flex items-center gap-1 
      xxl:px-6 xxl:py-3 xxl:text-lg 
      3xl:px-7 3xl:py-4 3xl:text-xl 
      4xl:px-8 4xl:py-5 4xl:text-2xl
      hover:bg-[#e07a1a] transition-colors font-encode">
                DEMANDER UN DEVIS <ChevronRight size={16} className="xxl:w-6 3xl:w-7 4xl:w-8" />
            </button>

            {/* Dropdown Menu */}
            {isCatalogueOpen && (
              <div className="absolute top-full left-0 mt-2 bg-white shadow-lg rounded-md overflow-hidden z-50 min-w-[17.5rem] animate-slideDown">
                {catalogueItems.map((item, index) => (
                  item.href === "#" ? (
                    <button
                      key={index}
                      className="block w-full text-left px-6 py-3 text-sm xxl:px-8 xxl:py-4 xxl:text-lg 
                      3xl:px-10 3xl:py-5 3xl:text-xl 
                      4xl:px-12 4xl:py-6 4xl:text-2xl
                      hover:bg-gray-100 cursor-pointer border-b border-gray-200 
                      last:border-b-0 flex items-center justify-between group 
                      transition-all duration-200"
                    >
                      <span className="text-gray-400 font-medium group-hover:text-black/60 transition-colors font-encode">
                        {item.name}
                      </span>

                      {item.hasSubmenu && (
                        <ChevronRight
                          size={16}
                          className="text-gray-400 group-hover:text-black/60 transition-colors 
                          xxl:w-6 3xl:w-7 4xl:w-8"
                        />
                      )}
                    </button>
                  ) : (
                    <a
                      key={index}
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-6 py-3 text-sm xxl:px-8 xxl:py-4 xxl:text-lg 
                      3xl:px-10 3xl:py-5 3xl:text-xl 
                      4xl:px-12 4xl:py-6 4xl:text-2xl
                      hover:bg-gray-100 cursor-pointer border-b border-gray-200 
                      last:border-b-0 flex items-center justify-between group 
                      transition-all duration-200"
                    >
                      <span className="text-gray-400 font-medium group-hover:text-black/60 transition-colors font-encode">
                        {item.name}
                      </span>

                      {item.hasSubmenu && (
                        <ChevronRight
                          size={16}
                          className="text-gray-400 group-hover:text-black/60 transition-colors 
                          xxl:w-6 3xl:w-7 4xl:w-8"
                        />
                      )}
                    </a>
                  )
                ))}
              </div>
            )}
          </div>

          {/* Mobile Navigation */}
          <div className="flex lg:hidden items-center justify-start w-full buttons_cta_mobile relative z-50">
            <div className="flex items-center gap-2" ref={dropdownRef}>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIsCatalogueOpen(!isCatalogueOpen);
                }}
                className="px-3 py-2 bg-[#F38820] text-white text-xs font-semibold flex items-center gap-1 hover:bg-[#e07a1a] transition-colors font-encode"
              >
                CATALOGUES
                <ChevronDown
                  size={14}
                  className={`transition-transform duration-300 ${isCatalogueOpen ? 'rotate-180' : ''
                    }`}
                />
              </button>
              <button onClick={() => scrollToSection('contact_form')} className="px-3 py-2 bg-[#F38820] text-white text-xs font-semibold flex items-center gap-1 hover:bg-[#e07a1a] transition-colors font-encode">
                DEMANDER UN DEVIS <ChevronRight size={14} />
              </button>

              {/* Mobile Dropdown Menu */}
              {isCatalogueOpen && (
                <div className="absolute top-full left-0 mt-2 bg-white shadow-lg rounded-md overflow-hidden z-50 min-w-[17.5rem] animate-slideDown">
                  {catalogueItems.map((item, index) => (
                    item.href === "#" ? (
                      <button
                        key={index}
                        className="block w-full text-left px-6 py-3 text-sm xxl:px-8 xxl:py-4 xxl:text-lg 3xl:px-10 3xl:py-5 3xl:text-xl 4xl:px-12 4xl:py-6 4xl:text-2xl
                               hover:bg-gray-100 cursor-pointer border-b border-gray-200 last:border-b-0 flex items-center justify-between group transition-all duration-200"
                      >
                        <span className="text-gray-400 font-medium group-hover:text-black/60 transition-colors font-encode">
                          {item.name}
                        </span>
                        {item.hasSubmenu && (
                          <ChevronRight
                            size={16}
                            className="text-gray-400 group-hover:text-black/60 transition-colors xxl:w-6 3xl:w-7 4xl:w-8"
                          />
                        )}
                      </button>
                    ) : (
                      <a
                        key={index}
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block px-6 py-3 text-sm xxl:px-8 xxl:py-4 xxl:text-lg 3xl:px-10 3xl:py-5 3xl:text-xl 4xl:px-12 4xl:py-6 4xl:text-2xl
                               hover:bg-gray-100 cursor-pointer border-b border-gray-200 last:border-b-0 flex items-center justify-between group transition-all duration-200"
                      >
                        <span className="text-gray-400 font-medium group-hover:text-black/60 transition-colors font-encode">
                          {item.name}
                        </span>
                        {item.hasSubmenu && (
                          <ChevronRight
                            size={16}
                            className="text-gray-400 group-hover:text-black/60 transition-colors xxl:w-6 3xl:w-7 4xl:w-8"
                          />
                        )}
                      </a>
                    )
                  ))}
                </div>
              )}
            </div>
          </div>

        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <ul className="lg:hidden flex flex-col gap-2 px-4 pb-4 text-white text-sm">
            {menuItems.map((item, index) => (
              <li key={index}>
                <a
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(item.id);
                  }}
                  className="block px-3 py-2 bg-[#00305c] hover:bg-[#004080]"
                >
                  {item.name}
                </a>
              </li>
            ))}

          </ul>
        )}

      </nav>
    </div>
  );
};

export default SogereuNavbar;
